import React from 'react';
import type { Cell, Row } from 'react-table';
import type { CustomColumnProps } from '../types';

const RowMemoized = ({ tableId, row, newId, count, getRowProps, getCellProps, sortedBy }: { tableId: string, row: Row, count: number, getRowProps: (row: Row) => Record<string, unknown>, getCellProps: (cell: Cell, row: Row) => Record<string, unknown>, sortedBy: string[], newId?: number }) => {
  const isDisabled = row.values.select?.disabled ?? false;
  const newEntry = newId && row.values.name.id && newId === row.values.name.id;
  return (
    <tr
      {...row.getRowProps(getRowProps(row))}
      data-row={`row-${row.depth ? 'child' : 'parent'}`}
      data-disabled={isDisabled}
      data-expanded={row.isExpanded}
      data-odd={count % 2 === 0 ? 'false' : 'true'}
      data-new-entry={newEntry}
    >
      {row.cells.map((cell) => {
        const accessor = cell.column.id;

        return (
          <td
            {...cell.getCellProps(getCellProps(cell, row))}
            key={`${tableId}--${cell.getCellProps().key}`}
            data-id={cell.getCellProps().key}
            data-column={`cell_${accessor}`}
            data-sorted={sortedBy.includes(accessor)}
            data-label={(cell.column as unknown as CustomColumnProps).title ?? cell.column.Header}
          >
            <div>{cell.render('Cell')}</div>
          </td>
        );
      })}
    </tr>
  );
};

export default React.memo(
  RowMemoized,
  (prevProps: { row: Row<{ updatedAt?: string }> }, newProps: { row: Row<{ updatedAt?: string }> }) => {
    if (null == prevProps.row.original.updatedAt && null == newProps.row.original.updatedAt) {
      return false;
    }

    return prevProps.row.original.updatedAt === newProps.row.original.updatedAt;
  },
);
